import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motDePasseOublie } from '../services/api';

const MotDePasseOublie = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [erreur, setErreur] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErreur('');
    setMessage('');
    try {
      const res = await motDePasseOublie(email);
      setMessage(res.data.message);
    } catch (err) {
      setErreur(err.response?.data?.message || 'Erreur lors de la demande');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: '#0A0A0A' }}>
      <div className="w-full max-w-md">

        <div className="text-center mb-6">
          <Link to="/" className="inline-block">
            <img src="/logo.jpg" alt="JJ Cars" className="h-12 w-auto object-contain mx-auto" />
          </Link>
        </div>

        <h1 className="text-white text-2xl font-black mb-1">Mot de passe oublié</h1>
        <p className="text-gray-500 mb-5 text-sm">
          Saisissez votre email, nous vous enverrons un lien pour réinitialiser votre mot de passe.
        </p>

        {erreur && (
          <div className="bg-red-900 bg-opacity-30 border border-red-500 text-red-400 p-2.5 rounded-xl mb-3 text-xs">
            {erreur}
          </div>
        )}
        {message && (
          <div className="bg-green-900 bg-opacity-30 border border-green-500 text-green-400 p-3 rounded-xl mb-3 text-sm">
            {message}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-3">
          <div>
            <label className="block text-xs font-semibold text-gray-400 mb-1">Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={{ background: '#1a1a1a', border: '1px solid #333', color: 'white' }}
              className="w-full px-3 py-2 rounded-xl text-sm focus:outline-none focus:border-yellow-400 transition"
              placeholder="votre@email.com"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{ background: '#F5A623' }}
            className="w-full text-black py-2 rounded-xl font-black text-sm hover:opacity-90 transition disabled:opacity-50"
          >
            {loading ? 'Envoi en cours...' : 'Envoyer le lien'}
          </button>
        </form>

        <p className="text-center text-gray-500 mt-5 text-sm">
          <Link to="/connexion" style={{ color: '#F5A623' }} className="font-bold hover:opacity-80">
            ← Retour à la connexion
          </Link>
        </p>
      </div>
    </div>
  );
};

export default MotDePasseOublie;
